/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {
    cloneElement,
    isValidElement,
    useCallback,
    useState,
} from 'react';
import useBreakpoint from 'use-breakpoint';
import { PageComponent } from '@root/pages/Type';
import classnames from 'classnames';
import SwipeableViews from 'react-swipeable-views';
import { flowRight } from 'lodash';
import { bindKeyboard, autoPlay } from 'react-swipeable-views-utils';
import styles from './HardwareSection.module.scss';

const BREAKPOINTS = { mobile: 0, tablet: 999, desktop: 1280 };

type SlideProps = {
    className?: string;
    index: string;
    src: string;
    alt: string;
    onClick?: () => void;
};

export const Slide: PageComponent<SlideProps> = ({
    className,
    src,
    alt,
    onClick,
}) => {
    return (
        <div
            className={classnames(styles.logo_content)}
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
        >
            <div className={classnames(styles.logo_inner, className)}>
                <img src={src} alt={alt} />
            </div>
        </div>
    );
};

const EnhancedSwipeableViews = flowRight(
    bindKeyboard,
    autoPlay,
)(SwipeableViews);

const MobileCarousel: PageComponent = ({ children }) => {
    const [index, setIndex] = useState(0);

    const handleChangeIndex = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (_index: number, _indexLatest: number, _meta: unknown) => {
            setIndex(_index);
        },
        [setIndex],
    );
    return (
        <div className={styles.logo_wrapper}>
            <EnhancedSwipeableViews
                index={index}
                onChangeIndex={handleChangeIndex}
                className={styles.logo_container}
                slideStyle={{
                    overflow: 'unset',
                }}
                style={{
                    padding: '0 80px',
                    overflow: 'unset',
                    width: '100%',
                }}
                containerStyle={{
                    width: '100%',
                }}
                slideClassName={styles.logo_content}
                ignoreNativeScroll
                enableMouseEvents
                autoplay={false}
                resistance
            >
                {React.Children.map(children, (_children, _index) => {
                    if (!isValidElement(_children)) {
                        return null;
                    }
                    return cloneElement(_children, {
                        key: _children.props.index,
                        onClick: () => setIndex(_index),
                    });
                })}
            </EnhancedSwipeableViews>
            <div className={styles.dots}>
                {React.Children.map(children, (_children, _index) => {
                    if (!isValidElement(_children)) {
                        return null;
                    }
                    return (
                        <span
                            key={`dot-${_children.props.index}`}
                            onClick={() => setIndex(_index)}
                            className={classnames(styles.dot, {
                                [styles.active]: index === _index,
                            })}
                        >
                            &#9679;
                        </span>
                    );
                })}
            </div>
        </div>
    );
};

type CarouselProps = {
    className?: string;
};
const Carousel: PageComponent<CarouselProps> = ({ children, ...props }) => {
    const { breakpoint } = useBreakpoint(BREAKPOINTS, 'desktop');
    if (breakpoint === 'mobile') {
        return <MobileCarousel {...props}>{children}</MobileCarousel>;
    }
    return (
        <div className={styles.logo_wrapper}>
            <div {...props}>
                {React.Children.map(children, (_children) => {
                    if (!isValidElement(_children)) {
                        return null;
                    }
                    return cloneElement(_children, {
                        key: _children.props.index,
                    });
                })}
            </div>
        </div>
    );
};

export default Carousel;
